
import { Component, Vue, Prop, Model, Emit } from "vue-property-decorator";

@Component({})
export default class DepartmentComponent extends Vue {
  name = "department";
}
